import { render, staticRenderFns } from "./BusinessUnitGroupsDashboard.vue?vue&type=template&id=1bff5253&scoped=true&"
import script from "./BusinessUnitGroupsDashboard.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitGroupsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff5253",
  null
  
)

export default component.exports